<div class="main-content">
  <div class="container-fluid">
              <div class="card">
                  <div class="card-header card-header-danger">
                      <h4 class="card-title">Lab Result</h4>
                  </div>
                  <div class="card-body">
                    <form [formGroup]="TestResultForm">
                      <div class="row">
                        <div class="col-md-6 mt-3">

                        <label>Choose Months<span style="color: red !important;">*</span> </label>
                        <ng-select  class="form-control" 
                        [(ngModel)]="selectedMonthsDates"
                        formControlName="selectedMonthsDates"
                        (change)="onMonthsSelectionChange($event)"
                        multiple="true"
                       >
                       <ng-option *ngFor="let date of availableDatesMonthes" [value]="date" [disabled]="isMonthsDateDisabled(date)"
                       >{{ date | date: 'MMMM yyyy'
                                }}
                      </ng-option>
                      </ng-select>
                      <mat-error class="mt-2"
                      *ngIf="fc.selectedMonthsDates.invalid && (fc.selectedMonthsDates.dirty || fc.selectedMonthsDates.touched)">
                      Months is required
                    </mat-error>

                 
                        </div>

                        <div class="col-md-6 mt-3">
                            <label>Items </label>
                            <ng-select  class="form-control" [items]="items" 
                            bindLabel="name" 
                            bindValue="id" 
                            formControlName="ItemId">
                          </ng-select>
                          <mat-error class="mt-2"
                          *ngIf="fc.ItemId.invalid && (fc.ItemId.dirty || fc.ItemId.touched)">
                          Item is required
                      </mat-error>
                        </div>
                        <div class="col-md-6 mt-3">
                          <div class="form-group"
                          >
                            <label>Category</label>
                            <ng-select  class="form-control" [items]="categories" 
                            bindLabel="name" 
                            bindValue="id" 
                            (change)="GetTestsByCatId($event.id)"
                            formControlName="CategoryId"  
                            >
                          </ng-select>
                          <mat-error class="mt-2"
                          *ngIf="fc.CategoryId.invalid && (fc.CategoryId.dirty || fc.CategoryId.touched)">
                          Category is required
                      </mat-error>
                          </div>
                      
                        </div>
                        <div class="col-md-6 mt-3">
                          <div class="form-group"
                          >
                            <label>Tests</label>
                            <ng-select  class="form-control" [items]="filteredTests" 
                            bindLabel="name" 
                            bindValue="id" 
                            formControlName="TestId"  
                            >
                          </ng-select>
                 
                          </div>
                      
                        </div>
                    
                        <div class="col-md-6 mt-3">
                          <div class="form-group"
                          >
                            <label>Branches </label>
                            <ng-select  class="form-control" [items]="AllBranchs" 
                            bindLabel="name" 
                            bindValue="id" 
                            formControlName="Branch"  
                            >
                          </ng-select>
                          <mat-error class="mt-2"
                          *ngIf="fc.Branch.invalid && (fc.Branch.dirty || fc.Branch.touched)">
                          Branch is required
                      </mat-error>
                          </div>
                        </div>
               
                
                      </div>
                      <button mat-raised-button type="submit"  class="btn primary pull-right" [disabled]="TestResultForm.invalid"  (click)="Submit()">Search</button>
                                  <div class="clearfix"></div>
                    </form>


                  </div>
              </div>


  
<!-- <div class="card" *ngIf="originaldata.length!=0">

  <div class="row mt-4 p-3">
    <div class="col-md-10">
        <mat-form-field>
            <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
        </mat-form-field>
    </div>
    <div class="col-md-2">
        <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportToExcel()" class="mb-4 p-button-success mr-2" pTooltip="XLS" tooltipPosition="bottom"></button>
        <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportToPDF()" class="mb-4 p-button-warning mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>
  
      
    </div>
 
</div>

                    <table  mat-table [dataSource]="dataSource" class="mat-elevation-z8">

                        <ng-container matColumnDef="TestName">
                            <th mat-header-cell *matHeaderCellDef> Test Name </th>
                            <td mat-cell *matCellDef="let element"> {{element.TestName}} </td>
                        </ng-container>

                        <ng-container matColumnDef="DateResult">
                            <th mat-header-cell *matHeaderCellDef>Date Result</th>
                            <td mat-cell *matCellDef="let element"> {{element.DateResult}} </td>
                               
                        </ng-container>

                        
                                     <ng-container matColumnDef="Result">
                                        <th mat-header-cell *matHeaderCellDef>Result</th>
                                        <td mat-cell *matCellDef="let element">
                                          <div style="margin-right: 15px;" class="mt-2">
                                            
                                     
                                        </div>
                                          <div *ngIf="element.Result=='PASS'">
                                            <span class="PassColor">{{element.Result}}</span></div> 
                                            <div *ngIf="element.Result=='FAIl'" class="d-flex align-items-center">
                                              <span class="FailColor">{{element.Result}}</span>
                                            </div>
                                        
                                        </td>
                                    </ng-container>
            
                                    
                             
                                    <ng-container matColumnDef="Note">
                                        <th mat-header-cell *matHeaderCellDef>Note</th>
                                        <td mat-cell *matCellDef="let element"> 
                                          {{element.Notes}}
                                           </td>
                                    </ng-container>
                                    <ng-container matColumnDef="summary">
                                      <td mat-footer-cell *matFooterCellDef colspan="6">
                                        <div class="row mt-3">
                                          <h4>Summary</h4>
                                        </div>
                                        <div class="row text-center mb-2">
                                          <div class="col-6">
                                           <strong>Total Pass : </strong>
                                           <span class="PassColor">{{ getTotalPass() }}</span>
                                          </div>
                                          <div class="col-6">
                                            <strong>Total Fail : </strong>
                                            <span class="FailColor">{{ getTotalFail() }}</span>
                                          </div>

                                        </div>
                                      </td>
                                    </ng-container>
                   
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        <tr mat-footer-row *matFooterRowDef="['summary']" class="example-second-footer-row"></tr>
                 
                    </table>
</div> -->
<div class="card" *ngIf="originaldata.length != 0">
  <div class="row mt-4 p-3">
    <div class="col-md-10 col-sm-12">
      <mat-form-field class="w-100">
        <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
      </mat-form-field>
    </div>
    <div class="col-md-2 col-sm-12 d-flex justify-content-end align-items-center mt-2 mt-md-0">
      <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportToExcel()"
        class="p-button-success mr-2" pTooltip="XLS" tooltipPosition="bottom"></button>
      <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportToPDF()" class="p-button-warning"
        pTooltip="PDF" tooltipPosition="bottom"></button>
    </div>
  </div>

  <div class="table-responsive">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 table">
      <ng-container matColumnDef="TestName">
        <th mat-header-cell *matHeaderCellDef> Test Name </th>
        <td mat-cell *matCellDef="let element"> {{element.TestName}} </td>
      </ng-container>

      <ng-container matColumnDef="DateResult">
        <th mat-header-cell *matHeaderCellDef>Date Result</th>
        <td mat-cell *matCellDef="let element"> {{element.DateResult}} </td>
      </ng-container>

      <ng-container matColumnDef="Result">
        <th mat-header-cell *matHeaderCellDef>Result</th>
        <td mat-cell *matCellDef="let element">
           
          <div class="mt-2">
            <div *ngIf="element.Result=='PASS'">
              <span class="PassColor">{{element.Result}}</span></div> 
              <div *ngIf="element.Result=='FAIl'" class="d-flex align-items-center">
                <span class="FailColor">{{element.Result}}</span>
              </div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="Note">
        <th mat-header-cell *matHeaderCellDef>Note</th>
        <td mat-cell *matCellDef="let element"> {{element.Notes}} </td>
      </ng-container>

      <ng-container matColumnDef="summary">
        <td mat-footer-cell *matFooterCellDef colspan="6">
          <div class="row mt-3">
            <h4>Summary</h4>
          </div>
          <div class="row text-center mb-2">
            <div class="col-6">
              <strong>Total Pass:</strong>
              <span class="PassColor">{{ getTotalPass() }}</span>
            </div>
            <div class="col-6">
              <strong>Total Fail:</strong>
              <span class="FailColor">{{ getTotalFail() }}</span>
            </div>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <tr mat-footer-row *matFooterRowDef="['summary']" class="example-second-footer-row"></tr>
    </table>
  </div>
</div>

    
  </div>
</div>